import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import { NgxTippyModule, NgxTippyProps } from 'ngx-tippy-wrapper'
import { TruncationDetectorDirective } from '../../directives/truncation-detector.directive'

@Component({
  selector: 'app-truncation-tooltip',
  standalone: true,
  imports: [NgClass, NgxTippyModule, TruncationDetectorDirective],
  templateUrl: './truncation-tooltip.component.html',
  host: {
    class: 'tw-inline-flex tw-min-w-0 tw-max-w-full'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TruncationTooltipComponent {
  public readonly text = input<string | null | undefined>(undefined)
  public readonly tooltipText = input<string | null | undefined>(undefined)
  public readonly tippyProps = input<NgxTippyProps>({ theme: 'dark' })
  public readonly badge = input(false)
  public readonly hostNgClass = input<string | Record<string, boolean> | Array<string | Record<string, boolean>> | undefined>(undefined)

  public readonly resolvedHostNgClass = computed(() => {
    const hostClasses = this.hostNgClass()
    if (hostClasses == null) return ''

    if (Array.isArray(hostClasses)) {
      return hostClasses.filter((entry) => entry != null && entry !== '')
    }

    return hostClasses
  })

  public readonly resolvedTooltipText = computed(() => {
    const tooltip = this.tooltipText()
    if (tooltip != null && tooltip !== '') return tooltip

    return this.text()
  })
}
